import * as Yup from "yup";
import checkout from "layouts/user/components/user-details/schemas/userForm";

const {
  formField: {
    organization,
    subOrganization,
    classData,
    email,
    userType,
    name,
    surname,
    nickName,
    studentNo,
    allBooksEnabled,
  },
} = checkout;

export default {
  validation: Yup.object().shape({
    [organization.name]: Yup.object().nullable().required(organization.errorMsg),
    [subOrganization.name]: Yup.object().nullable().required(subOrganization.errorMsg),
    [classData.name]: Yup.mixed().test("is required", classData.errorMsg, (value) => {
      if (!value) return false;
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return Boolean(value?.value);
    }),
    [email.name]: Yup.string().required(email.errorMsg),
    [userType.name]: Yup.object().required(userType.errorMsg),
    [name.name]: Yup.string().required(name.errorMsg),
    [surname.name]: Yup.string().required(surname.errorMsg),
    [nickName.name]: Yup.string().nullable(),
    [studentNo.name]: Yup.number().nullable(),
    [allBooksEnabled.name]: Yup.boolean(),
  }),
};
